<template>
  <div class="wallet-page container-lg py-3 py-md-4 px-3">
    <header class="card border-0 shadow-sm mb-3">
      <div class="card-body p-3 p-md-4">
        <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
          <div>
            <h1 class="h3 mb-1 text-body">
              <i class="bi bi-wallet2 me-2 text-primary" aria-hidden="true"></i>Wallet
            </h1>
            <p class="mb-0 text-muted small">
              Cuentas sincronizadas desde Wallet by BudgetBakers.
              <span v-if="config.ultimoSyncAt">
                Última sincronización: {{ fechaHora(config.ultimoSyncAt) }}
                <span v-if="config.ultimoSyncEstado === 'error'" class="text-danger">({{ config.ultimoSyncError }})</span>
              </span>
            </p>
          </div>
          <div v-if="config.configured" class="d-flex gap-2 flex-wrap">
            <select v-model.number="meses" class="form-select form-select-sm w-auto" aria-label="Meses de histórico" @change="cargarPanel">
              <option :value="6">6 meses</option>
              <option :value="12">12 meses</option>
              <option :value="24">24 meses</option>
            </select>
            <button type="button" class="btn btn-primary btn-sm" :disabled="sincronizando" @click="sincronizar(false)">
              <span v-if="sincronizando" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
              <i v-else class="bi bi-arrow-repeat me-1" aria-hidden="true"></i>
              {{ sincronizando ? 'Sincronizando…' : 'Sincronizar' }}
            </button>
          </div>
        </div>
      </div>
    </header>

    <div v-if="avisoToken" :class="['alert', 'py-2', 'small', 'd-flex', 'justify-content-between', 'align-items-center', 'gap-2', avisoToken.clase]" role="alert">
      <span><i class="bi bi-key me-1" aria-hidden="true"></i>{{ avisoToken.texto }}</span>
      <button type="button" class="btn btn-sm btn-light" @click="cambiarTab('config')">Renovar token</button>
    </div>
    <div v-if="cuentasDescuadradas.length && tab !== 'cuentas'" class="alert alert-warning py-2 small d-flex justify-content-between align-items-center gap-2" role="status">
      <span><i class="bi bi-exclamation-triangle me-1" aria-hidden="true"></i>{{ cuentasDescuadradas.length }} {{ cuentasDescuadradas.length === 1 ? 'cuenta no cuadra' : 'cuentas no cuadran' }} con Wallet.</span>
      <button type="button" class="btn btn-sm btn-light" @click="cambiarTab('cuentas')">Ver detalle</button>
    </div>
    <div v-if="mensaje" class="alert alert-success py-2 small" role="status">{{ mensaje }}</div>
    <div v-if="error" class="alert alert-danger py-2 small" role="alert">{{ error }}</div>

    <div v-if="cargando && !panel" class="text-center text-muted py-5" role="status">
      <div class="spinner-border text-primary mb-2" aria-hidden="true"></div>
      <div>Cargando…</div>
    </div>

    <template v-else>
      <ul class="nav nav-tabs wallet-tabs mb-3" role="tablist">
        <li v-for="t in tabsVisibles" :key="t.id" class="nav-item" role="presentation">
          <button
            type="button"
            class="nav-link"
            role="tab"
            :class="{ active: tab === t.id }"
            :aria-selected="tab === t.id"
            @click="cambiarTab(t.id)"
          >
            <i :class="['bi', t.icon, 'me-1']" aria-hidden="true"></i>{{ t.label }}
            <span v-if="t.id === 'movimientos' && pendientes > 0" class="badge rounded-pill bg-secondary ms-1">{{ pendientes }}</span>
          </button>
        </li>
      </ul>

      <!-- RESUMEN -->
      <section v-if="tab === 'resumen' && panel" aria-label="Resumen">
        <div v-if="nuevosTotal > 0" class="alert alert-info py-2 small d-flex justify-content-between align-items-center gap-2" role="status">
          <span><i class="bi bi-bell me-1" aria-hidden="true"></i>{{ nuevosTotal }} {{ nuevosTotal === 1 ? 'movimiento nuevo' : 'movimientos nuevos' }} desde tu última visita</span>
          <button type="button" class="btn btn-sm btn-light" @click="marcarVistos">Marcar como vistos</button>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6 col-lg-3">
            <div class="card border-0 shadow-sm h-100 kpi"><div class="card-body">
              <div class="kpi-label">Patrimonio total</div>
              <div class="kpi-value">{{ euros(panel.patrimonioTotal) }}</div>
              <div class="kpi-sub">{{ cuentasActivas.length }} cuentas activas</div>
            </div></div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="card border-0 shadow-sm h-100 kpi kpi-link" role="button" tabindex="0" aria-label="Explorar los gastos de este mes"
              @click="explorar({ tipo: 'gasto' })" @keyup.enter="explorar({ tipo: 'gasto' })"><div class="card-body">
              <div class="kpi-label">Gastos este mes <i class="bi bi-arrow-right-short" aria-hidden="true"></i></div>
              <div class="kpi-value">{{ euros(kpis.gastosMes) }}</div>
              <div class="kpi-sub">Proyección a fin de mes: {{ euros(kpis.proyeccionGastoMes) }}</div>
            </div></div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="card border-0 shadow-sm h-100 kpi kpi-link" role="button" tabindex="0" aria-label="Explorar los ingresos de este mes"
              @click="explorar({ tipo: 'ingreso' })" @keyup.enter="explorar({ tipo: 'ingreso' })"><div class="card-body">
              <div class="kpi-label">Ingresos este mes <i class="bi bi-arrow-right-short" aria-hidden="true"></i></div>
              <div class="kpi-value">{{ euros(kpis.ingresosMes) }}</div>
              <div class="kpi-sub">Ahorro: {{ euros(kpis.ahorroMes) }}</div>
            </div></div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="card border-0 shadow-sm h-100 kpi"><div class="card-body">
              <div class="kpi-label">Tasa de ahorro</div>
              <div class="kpi-value">{{ kpis.tasaAhorroMes != null ? kpis.tasaAhorroMes + ' %' : '—' }}</div>
              <div class="kpi-sub">Gasto medio mensual: {{ euros(kpis.gastoMensualMedio) }}</div>
            </div></div>
          </div>
        </div>

        <!-- Liquidez -->
        <div class="card border-0 shadow-sm mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h2 class="h5 mb-0"><i class="bi bi-droplet-half me-1 text-primary" aria-hidden="true"></i>Liquidez</h2>
              <button type="button" class="btn btn-outline-primary btn-sm" @click="nuevoGrupo">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Grupo
              </button>
            </div>
            <p class="small text-muted">
              Elige qué cuentas suman en cada indicador. Los meses de colchón son cuánto aguantarías al ritmo de gasto medio.
            </p>
            <p v-if="!panel.grupos.length && !grupoEdit" class="text-muted small mb-0">
              Aún no tienes grupos. Crea uno, p. ej. «Disponible» con tus cuentas corrientes y de ahorro.
            </p>
            <div class="row g-3">
              <div v-for="g in panel.grupos" :key="g.id" class="col-md-6 col-xl-4">
                <div class="border rounded p-3 h-100 liquidez-card">
                  <div class="d-flex justify-content-between">
                    <div class="fw-semibold">{{ g.nombre }}</div>
                    <div class="btn-group btn-group-sm">
                      <button type="button" class="btn btn-link btn-sm p-0 me-2" :aria-label="`Editar ${g.nombre}`" @click="editarGrupo(g)"><i class="bi bi-pencil"></i></button>
                      <button type="button" class="btn btn-link btn-sm p-0 text-danger" :aria-label="`Borrar ${g.nombre}`" @click="borrarGrupo(g)"><i class="bi bi-trash"></i></button>
                    </div>
                  </div>
                  <div class="liquidez-total" :class="{ 'text-danger': g.total < 0 }">{{ euros(g.total) }}</div>
                  <div v-if="g.mesesColchon != null" class="small text-muted mb-2">
                    <i class="bi bi-shield-check me-1" aria-hidden="true"></i>{{ g.mesesColchon }} meses de colchón
                  </div>
                  <ul class="list-unstyled small mb-0">
                    <li v-for="c in g.cuentasDetalle" :key="c.id" class="d-flex justify-content-between">
                      <span><span class="dot" :style="{ background: c.color || '#adb5bd' }"></span>{{ c.nombre }}</span>
                      <span>{{ importe(c.saldo, c.divisa) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <form v-if="grupoEdit" class="border rounded p-3 mt-3 bg-light" @submit.prevent="guardarGrupo">
              <div class="mb-2">
                <label class="form-label small fw-semibold" for="grupo-nombre">Nombre del grupo</label>
                <input id="grupo-nombre" v-model="grupoEdit.nombre" class="form-control form-control-sm" maxlength="60" required />
              </div>
              <fieldset>
                <legend class="form-label small fw-semibold">Cuentas incluidas</legend>
                <div class="row">
                  <div v-for="c in panel.cuentas" :key="c.id" class="col-sm-6">
                    <div class="form-check">
                      <input :id="`gc-${c.id}`" v-model="grupoEdit.cuentas" class="form-check-input" type="checkbox" :value="c.id" />
                      <label class="form-check-label small" :for="`gc-${c.id}`">
                        {{ c.nombre }} <span class="text-muted">({{ importe(c.saldo, c.divisa) }})</span>
                        <span v-if="c.archivada" class="badge bg-light text-muted">archivada</span>
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
              <div class="small mt-2">Suma seleccionada: <strong>{{ euros(sumaSeleccion) }}</strong></div>
              <div class="mt-2 d-flex gap-2">
                <button type="submit" class="btn btn-primary btn-sm">Guardar</button>
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="grupoEdit = null">Cancelar</button>
              </div>
            </form>
          </div>
        </div>

        <div v-if="panel.estadisticas.insights.length" class="alert alert-warning small">
          <div v-for="(i, idx) in panel.estadisticas.insights" :key="idx">
            <i class="bi bi-lightbulb me-1" aria-hidden="true"></i>{{ i.mensaje }}
          </div>
        </div>

        <div class="row g-3">
          <div class="col-lg-7">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body">
                <h2 class="h6">Ingresos y gastos por mes <small class="text-muted fw-normal">· pulsa un mes para explorarlo</small></h2>
                <div class="chart-box">
                  <Bar :data="chartMensual" :options="chartOpciones" aria-label="Gráfico de ingresos y gastos por mes" role="img" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body">
                <h2 class="h6">Gasto por categoría ({{ nombreMes(panel.estadisticas.mesActual) }})</h2>
                <p class="small text-muted">Comparado con la media de los 3 meses anteriores.</p>
                <table class="table table-sm small mb-0 align-middle">
                  <thead><tr><th scope="col">Categoría</th><th scope="col" class="text-end">Este mes</th><th scope="col" class="text-end">Media</th><th scope="col" class="text-end">Δ</th></tr></thead>
                  <tbody>
                    <tr v-for="c in categoriasMes" :key="c.id">
                      <td>
                        <a href="#" class="text-body text-decoration-none" @click.prevent="verCategoria(c.id)">{{ c.nombre }}</a>
                        <div class="cat-bar" :style="{ width: barraPct(c.mesActual) + '%' }" aria-hidden="true"></div>
                      </td>
                      <td class="text-end">{{ euros(c.mesActual) }}</td>
                      <td class="text-end text-muted">{{ euros(c.mediaPrevia) }}</td>
                      <td class="text-end">
                        <span v-if="c.variacionPct === 0" class="text-muted">=</span>
                        <span v-else-if="c.variacionPct != null" :class="c.variacionPct > 0 ? 'text-danger' : 'text-success'">
                          <i :class="['bi', c.variacionPct > 0 ? 'bi-arrow-up' : 'bi-arrow-down']" aria-hidden="true"></i>{{ Math.abs(c.variacionPct) }}%
                        </span>
                        <span v-else class="text-muted">nuevo</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-0 shadow-sm mt-3">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h2 class="h6 mb-0">Últimos movimientos</h2>
              <div class="btn-group btn-group-sm" role="group" aria-label="Paginación de últimos movimientos">
                <button type="button" class="btn btn-outline-secondary" :disabled="ultimosPagina === 0" aria-label="Más recientes" @click="cambiarPaginaUltimos(-1)"><i class="bi bi-chevron-left" aria-hidden="true"></i></button>
                <span class="btn btn-outline-secondary disabled">Pág. {{ ultimosPagina + 1 }}</span>
                <button type="button" class="btn btn-outline-secondary" :disabled="!ultimosHayMas" aria-label="Más antiguos" @click="cambiarPaginaUltimos(1)"><i class="bi bi-chevron-right" aria-hidden="true"></i></button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-sm small mb-0 align-middle">
                <thead><tr><th scope="col">Fecha</th><th scope="col">Comercio / nota</th><th scope="col">Cuenta</th><th scope="col" class="text-end">Importe</th></tr></thead>
                <tbody>
                  <tr v-if="!ultimos.length"><td colspan="4" class="text-center text-muted py-3">Sin movimientos</td></tr>
                  <tr v-for="m in ultimos" :key="m.id" :class="{ 'mov-nuevo': esNuevo(m) }">
                    <td class="text-nowrap">{{ fecha(m.fecha) }}</td>
                    <td>
                      <div>{{ m.beneficiario || '—' }}</div>
                      <div v-if="m.nota" class="text-muted text-truncate mov-nota">{{ m.nota }}</div>
                    </td>
                    <td class="text-muted">{{ m.cuenta_nombre }}</td>
                    <td class="text-end text-nowrap" :class="m.importe < 0 ? '' : 'text-success'">{{ importe(m.importe, m.divisa) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card border-0 shadow-sm mt-3">
          <div class="card-body">
            <h2 class="h6">Dónde más gastas ({{ meses }} meses)</h2>
            <div class="row small">
              <div v-for="b in panel.estadisticas.topBeneficiarios" :key="b.nombre" class="col-sm-6 d-flex justify-content-between border-bottom py-1">
                <span class="text-truncate me-2">{{ b.nombre }} <span class="text-muted">· {{ b.veces }}×</span></span>
                <span>{{ euros(b.total) }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- EXPLORAR -->
      <WalletExplorar
        v-if="tab === 'explorar' && panel"
        :cuentas="panel.cuentas"
        :divisa="panel.divisaBase || 'EUR'"
        :foco="focoExplorar"
      />

      <!-- CUENTAS -->
      <section v-if="tab === 'cuentas' && panel" aria-label="Cuentas">
        <div v-if="cuentasDescuadradas.length" class="alert alert-warning small">
          <p class="mb-2">
            <i class="bi bi-exclamation-triangle me-1" aria-hidden="true"></i>
            En estas cuentas Vida no tiene todos los movimientos que dice Wallet, así que el saldo no puede cuadrar.
            Suele arreglarse re-sincronizando todo el histórico.
          </p>
          <button type="button" class="btn btn-sm btn-warning" :disabled="sincronizando" @click="sincronizar(true)">
            <i class="bi bi-cloud-download me-1" aria-hidden="true"></i>Re-sincronizar todo el histórico
          </button>
        </div>
        <div class="card border-0 shadow-sm">
          <div class="table-responsive">
            <table class="table table-hover mb-0 small align-middle">
              <caption class="px-3 small">
                «Cuadrar»: escribe el saldo que muestra Wallet hoy y Vida guardará la diferencia (la API no informa del saldo
                actual ni, a veces, del inicial de las cuentas conectadas al banco). Los movimientos nuevos se siguen sumando.
              </caption>
              <thead><tr><th scope="col">Cuenta</th><th scope="col">Tipo</th><th scope="col" class="text-end">Saldo</th><th scope="col" class="text-end">Movs. Vida / Wallet</th><th scope="col">Último</th><th scope="col"><span class="visually-hidden">Acciones</span></th></tr></thead>
              <tbody>
                <tr v-for="c in panel.cuentas" :key="c.id" :class="{ 'text-muted': c.archivada }">
                  <td>
                    <span class="dot" :style="{ background: c.color || '#adb5bd' }"></span>{{ c.nombre }}
                    <span v-if="c.archivada" class="badge bg-light text-muted ms-1">archivada</span>
                    <span v-if="c.excluirStats" class="badge bg-light text-muted ms-1">fuera de estadísticas</span>
                    <div v-for="(a, i) in c.avisos" :key="i" class="text-warning-emphasis">
                      <i class="bi bi-exclamation-triangle me-1" aria-hidden="true"></i>{{ a }}
                    </div>
                  </td>
                  <td>{{ tipoCuenta(c.tipo) }}</td>
                  <td class="text-end fw-semibold" :class="{ 'text-danger': c.saldo < 0 }">
                    <span v-if="c.saldoAproximado" title="Incluye movimientos en una tercera divisa convertidos de forma aproximada">≈ </span>{{ importe(c.saldo, c.divisa) }}
                    <div v-if="c.ajuste != null" class="fw-normal text-muted">
                      ajuste {{ c.ajuste > 0 ? '+' : '' }}{{ importe(c.ajuste, c.divisa) }}
                    </div>
                  </td>
                  <td class="text-end">
                    {{ c.movimientos }} / {{ c.movimientosWallet != null ? c.movimientosWallet : '—' }}
                  </td>
                  <td>{{ c.ultimoMovimiento ? fecha(c.ultimoMovimiento) : '—' }}</td>
                  <td class="text-nowrap text-end">
                    <button type="button" class="btn btn-outline-secondary btn-sm" :aria-label="`Cuadrar saldo de ${c.nombre}`" @click="cuadrarSaldo(c)">
                      <i class="bi bi-check2-square me-1" aria-hidden="true"></i>Cuadrar
                    </button>
                    <button v-if="c.ajuste != null" type="button" class="btn btn-link btn-sm text-danger" :aria-label="`Quitar ajuste de ${c.nombre}`" @click="quitarAjuste(c)">
                      <i class="bi bi-x-lg" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <!-- MOVIMIENTOS -->
      <section v-if="tab === 'movimientos'" aria-label="Movimientos">
        <div class="d-flex flex-wrap gap-2 mb-2">
          <select v-model="filtro.vista" class="form-select form-select-sm w-auto" aria-label="Vista" @change="cargarMovimientos">
            <option value="revisar">Pendientes de revisar</option>
            <option value="todos">Todos</option>
            <option value="traspasos">Traspasos entre cuentas</option>
          </select>
          <select v-model="filtro.categoria" class="form-select form-select-sm w-auto" aria-label="Categoría" @change="cargarMovimientos">
            <option value="">Todas las categorías</option>
            <option value="sin_categoria">Sin categoría</option>
            <option v-for="c in categorias" :key="c.id" :value="c.id">{{ c.nombre }}</option>
          </select>
          <input v-model="filtro.mes" type="month" class="form-control form-control-sm w-auto" aria-label="Mes" @change="cargarMovimientos" />
          <input v-model="filtro.q" type="search" class="form-control form-control-sm w-auto" placeholder="Buscar comercio o nota" aria-label="Buscar" @keyup.enter="cargarMovimientos" />
        </div>
        <p class="small text-muted">
          <i class="bi bi-magic me-1" aria-hidden="true"></i>
          Las categorías se asignan solas: primero tus reglas, luego la de Wallet y, si es «Unknown», la que más usas para ese comercio
          (<span class="badge fuente-aprendida">aprendida</span>). Al corregir una puedes crear una regla para que no vuelva a pasar.
          Los <strong>traspasos entre tus cuentas</strong> no cuentan como gasto ni ingreso: se detectan solos (mismo importe que sale de
          una cuenta y entra en otra en ≤3 días, o Wallet los marca); si alguno no lo es, elige otra categoría, y para marcar uno a mano
          elige «Traspaso entre cuentas».
        </p>
        <div v-if="traspasosPorConfirmar > 0" class="alert alert-light border d-flex flex-wrap justify-content-between align-items-center gap-2 py-2 small">
          <span>
            <i class="bi bi-arrow-left-right me-1" aria-hidden="true"></i>
            <strong>{{ traspasosPorConfirmar }}</strong> traspasos detectados por importe esperan tu confirmación.
            Revisa que la cuenta de la pareja (→ / ←) tenga sentido y confírmalos de una vez.
          </span>
          <button type="button" class="btn btn-success btn-sm" :disabled="aceptandoTodos" @click="aceptarTraspasos(null)">
            <i class="bi bi-check2-all me-1" aria-hidden="true"></i>Confirmar todos los traspasos detectados
          </button>
        </div>
        <div class="card border-0 shadow-sm">
          <div class="table-responsive">
            <table class="table table-sm mb-0 small align-middle">
              <thead><tr><th scope="col">Fecha</th><th scope="col">Comercio / nota</th><th scope="col">Cuenta</th><th scope="col" class="text-end">Importe</th><th scope="col">Categoría</th></tr></thead>
              <tbody>
                <tr v-if="!movimientos.length"><td colspan="5" class="text-center text-muted py-4">Nada por aquí 🎉</td></tr>
                <tr v-for="m in movimientos" :key="m.id" :class="{ 'mov-nuevo': esNuevo(m) }">
                  <td class="text-nowrap">{{ fecha(m.fecha) }}</td>
                  <td>
                    <div>{{ m.beneficiario || '—' }}</div>
                    <div v-if="m.nota" class="text-muted text-truncate mov-nota">{{ m.nota }}</div>
                  </td>
                  <td class="text-muted">{{ m.cuenta_nombre }}</td>
                  <td class="text-end text-nowrap" :class="m.importe < 0 ? '' : 'text-success'">{{ importe(m.importe, m.divisa) }}</td>
                  <td class="mov-cat">
                    <select
                      class="form-select form-select-sm"
                      :value="m.categoria_efectiva_id || ''"
                      :aria-label="`Categoría de ${m.beneficiario || 'movimiento'}`"
                      @change="cambiarCategoria(m, $event.target.value)"
                    >
                      <option value="">— Sin categoría —</option>
                      <option v-for="c in categorias" :key="c.id" :value="c.id">{{ c.nombre }}</option>
                    </select>
                    <div v-if="m.es_traspaso" class="d-flex flex-wrap align-items-center gap-1 mt-1">
                      <span class="badge fuente-traspaso" :title="MOTIVOS_TRASPASO[m.traspaso_motivo] || ''">
                        <i class="bi bi-arrow-left-right me-1" aria-hidden="true"></i>{{ ETIQUETA_MOTIVO[m.traspaso_motivo] || 'traspaso' }}
                      </span>
                      <span v-if="m.pareja_cuenta_nombre" class="small text-muted text-truncate pareja" :title="`Pareja en ${m.pareja_cuenta_nombre}`">
                        {{ m.importe < 0 ? '→' : '←' }} {{ m.pareja_cuenta_nombre }}
                      </span>
                      <template v-if="m.traspaso_motivo === 'pareja'">
                        <button type="button" class="btn btn-sm btn-success py-0 px-2 ms-auto" :aria-label="`Confirmar traspaso ${m.beneficiario || ''}`" title="Sí, es un traspaso entre mis cuentas" @click="aceptarTraspasos([m.id])">
                          <i class="bi bi-check-lg" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary py-0 px-2" :aria-label="`No es traspaso ${m.beneficiario || ''}`" title="No es un traspaso" @click="cambiarCategoria(m, '')">
                          <i class="bi bi-x-lg" aria-hidden="true"></i>
                        </button>
                      </template>
                    </div>
                    <span v-else-if="m.categoria_fuente && m.categoria_fuente !== 'wallet'" :class="['badge', 'mt-1', `fuente-${m.categoria_fuente}`]">{{ m.categoria_fuente }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="form-check mt-2">
          <input id="crear-regla" v-model="crearReglaAlCorregir" class="form-check-input" type="checkbox" />
          <label class="form-check-label small" for="crear-regla">Al corregir una categoría, crear regla con el nombre del comercio</label>
        </div>
      </section>

      <!-- RECURRENTES -->
      <section v-if="tab === 'recurrentes' && panel" aria-label="Cargos recurrentes">
        <p class="small text-muted">
          Cobros que se repiten cada mes por un importe parecido, detectados automáticamente. Revisa si sigues usando cada servicio
          y si te han cambiado el precio.
        </p>
        <div class="row g-3 mb-3">
          <div class="col-6 col-lg-3"><div class="card border-0 shadow-sm kpi"><div class="card-body">
            <div class="kpi-label">Coste anual activo</div>
            <div class="kpi-value">{{ euros(costeRecurrente) }}</div>
          </div></div></div>
          <div class="col-6 col-lg-3"><div class="card border-0 shadow-sm kpi"><div class="card-body">
            <div class="kpi-label">Cambios de precio</div>
            <div class="kpi-value">{{ panel.recurrentes.filter((r) => r.cambioPrecio).length }}</div>
          </div></div></div>
        </div>
        <div class="card border-0 shadow-sm">
          <div class="table-responsive">
            <table class="table table-sm mb-0 small align-middle">
              <thead><tr><th scope="col">Comercio</th><th scope="col" class="text-end">Último</th><th scope="col">Precio</th><th scope="col" class="text-end">Al año</th><th scope="col">Próximo</th></tr></thead>
              <tbody>
                <tr v-if="!panel.recurrentes.length"><td colspan="5" class="text-center text-muted py-4">No se han detectado cargos recurrentes todavía.</td></tr>
                <tr v-for="r in panel.recurrentes" :key="r.clave" :class="{ 'text-muted': !r.activo }">
                  <td>{{ r.nombre }} <span class="text-muted">· {{ r.veces }} meses</span> <span v-if="!r.activo" class="badge bg-light text-muted">parado</span></td>
                  <td class="text-end">{{ euros(r.importeUltimo) }}</td>
                  <td>
                    <span v-if="r.cambioPrecio === 'sube'" class="text-danger"><i class="bi bi-arrow-up" aria-hidden="true"></i> sube {{ r.cambioPct }}% (antes {{ euros(r.importeAnterior) }})</span>
                    <span v-else-if="r.cambioPrecio === 'baja'" class="text-success"><i class="bi bi-arrow-down" aria-hidden="true"></i> baja {{ Math.abs(r.cambioPct) }}%</span>
                    <span v-else class="text-muted">estable</span>
                  </td>
                  <td class="text-end">{{ euros(r.costeAnual) }}</td>
                  <td>{{ r.activo ? fecha(r.proximaFecha) : '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <!-- AUTOMATIZACIÓN: reglas + alertas -->
      <section v-if="tab === 'auto'" aria-label="Reglas y alertas">
        <div class="row g-3">
          <div class="col-lg-6">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body">
                <h2 class="h6"><i class="bi bi-bell me-1" aria-hidden="true"></i>Alertas (notificación al móvil)</h2>
                <form class="row g-2 align-items-end mb-3" @submit.prevent="crearAlerta">
                  <div class="col-12 col-sm-6">
                    <label class="form-label small" for="al-tipo">Tipo</label>
                    <select id="al-tipo" v-model="alertaNueva.tipo" class="form-select form-select-sm" @change="alertaNueva.objetivo = ''">
                      <option value="saldo_bajo">Saldo por debajo de…</option>
                      <option value="gasto_alto">Cargo mayor de…</option>
                      <option value="categoria_mes">Categoría supera en el mes…</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-6">
                    <label class="form-label small" for="al-obj">Sobre</label>
                    <select id="al-obj" v-model="alertaNueva.objetivo" class="form-select form-select-sm" :required="alertaNueva.tipo !== 'gasto_alto'">
                      <option v-if="alertaNueva.tipo === 'gasto_alto'" value="">Cualquier cuenta</option>
                      <template v-if="alertaNueva.tipo === 'categoria_mes'">
                        <option v-for="c in categorias" :key="c.id" :value="`categoria:${c.id}`">{{ c.nombre }}</option>
                      </template>
                      <template v-else>
                        <optgroup v-if="alertaNueva.tipo === 'saldo_bajo' && panel?.grupos.length" label="Grupos de liquidez">
                          <option v-for="g in panel.grupos" :key="g.id" :value="`grupo:${g.id}`">{{ g.nombre }}</option>
                        </optgroup>
                        <optgroup label="Cuentas">
                          <option v-for="c in cuentasActivas" :key="c.id" :value="`cuenta:${c.id}`">{{ c.nombre }}</option>
                        </optgroup>
                      </template>
                    </select>
                  </div>
                  <div class="col-8">
                    <label class="form-label small" for="al-umbral">Umbral ({{ panel?.divisaBase || 'EUR' }})</label>
                    <input id="al-umbral" v-model.number="alertaNueva.umbral" type="number" min="0" step="0.01" class="form-control form-control-sm" required />
                  </div>
                  <div class="col-4"><button type="submit" class="btn btn-primary btn-sm w-100">Añadir</button></div>
                </form>
                <ul class="list-group list-group-flush small">
                  <li v-if="!alertas.length" class="list-group-item text-muted">Sin alertas. Ejemplo: avisarme si «Disponible» baja de 2.000 €.</li>
                  <li v-for="a in alertas" :key="a.id" class="list-group-item d-flex justify-content-between align-items-start gap-2">
                    <div>
                      <div>
                        <i v-if="a.disparada" class="bi bi-exclamation-triangle-fill text-warning me-1" aria-label="Activada"></i>
                        {{ descripcionAlerta(a) }}
                      </div>
                      <div v-if="a.ultimo_mensaje" class="text-muted">Último aviso {{ fechaHora(a.ultimo_aviso_at) }}: {{ a.ultimo_mensaje }}</div>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                      <div class="form-check form-switch m-0">
                        <input class="form-check-input" type="checkbox" :checked="!!a.activa" :aria-label="`Activar alerta ${a.id}`" @change="toggleAlerta(a, $event.target.checked)" />
                      </div>
                      <button type="button" class="btn btn-link btn-sm p-0 text-danger" aria-label="Borrar alerta" @click="borrarAlerta(a)"><i class="bi bi-trash"></i></button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body">
                <h2 class="h6"><i class="bi bi-magic me-1" aria-hidden="true"></i>Reglas de categorización</h2>
                <p class="small text-muted">Si el comercio o la nota contiene el texto, se asigna la categoría (gana la regla más específica).</p>
                <form class="row g-2 mb-3" @submit.prevent="crearRegla">
                  <div class="col-sm-5"><input v-model="reglaNueva.patron" class="form-control form-control-sm" placeholder="Texto, p. ej. repsol" aria-label="Texto de la regla" minlength="2" required /></div>
                  <div class="col-sm-5">
                    <select v-model="reglaNueva.categoria_id" class="form-select form-select-sm" aria-label="Categoría de la regla" required>
                      <option value="" disabled>Categoría…</option>
                      <option v-for="c in categorias" :key="c.id" :value="c.id">{{ c.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-sm-2"><button type="submit" class="btn btn-primary btn-sm w-100">Añadir</button></div>
                </form>
                <ul class="list-group list-group-flush small">
                  <li v-if="!reglas.length" class="list-group-item text-muted">Sin reglas todavía.</li>
                  <li v-for="r in reglas" :key="r.id" class="list-group-item d-flex justify-content-between">
                    <span>«{{ r.patron }}» → <strong>{{ r.categoria_nombre || r.categoria_id }}</strong></span>
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" aria-label="Borrar regla" @click="borrarRegla(r)"><i class="bi bi-trash"></i></button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CONFIGURACIÓN -->
      <section v-if="tab === 'config'" aria-label="Configuración">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <h2 class="h6">Conexión con Wallet</h2>
            <p class="small text-muted">
              Necesitas Wallet Premium. En <a href="https://web.budgetbakers.com" target="_blank" rel="noopener noreferrer">web.budgetbakers.com</a>
              → Ajustes → API, genera un token y pégalo aquí. Se guarda cifrado y solo se usa para leer tus datos.
            </p>
            <form class="row g-2" @submit.prevent="guardarConfig">
              <div class="col-md-5">
                <label class="form-label small" for="wallet-token">Token API</label>
                <input id="wallet-token" v-model="tokenInput" type="password" class="form-control form-control-sm" autocomplete="off"
                  :placeholder="config.configured ? '•••••• (déjalo vacío para mantener el actual)' : 'Pega tu token'"
                  @input="alCambiarToken" />
              </div>
              <div class="col-6 col-md-2">
                <label class="form-label small" for="wallet-caduca">El token caduca el</label>
                <input id="wallet-caduca" v-model="caducaInput" type="date" class="form-control form-control-sm" />
              </div>
              <div class="col-6 col-md-2">
                <label class="form-label small" for="wallet-desde">Histórico desde</label>
                <input id="wallet-desde" v-model="desdeInput" type="date" class="form-control form-control-sm" />
              </div>
              <div class="col-md-3 d-flex align-items-end">
                <button type="submit" class="btn btn-primary btn-sm w-100" :disabled="guardando">
                  {{ guardando ? 'Comprobando…' : config.configured ? 'Guardar' : 'Conectar' }}
                </button>
              </div>
            </form>
            <div v-if="config.configured" class="d-flex flex-wrap gap-2 mt-3">
              <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="sincronizando" @click="sincronizar(true)">
                <i class="bi bi-cloud-download me-1" aria-hidden="true"></i>Re-sincronizar todo el histórico
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm" @click="desconectar">
                <i class="bi bi-plug me-1" aria-hidden="true"></i>Desconectar y borrar datos locales
              </button>
            </div>
            <p class="small text-muted mt-3 mb-0">
              Wallet da tokens de como mucho 1 año: pon la fecha que elegiste al crearlo y te avisaremos al móvil 30, 7 y 1 días antes.
              El histórico se importa desde el primer movimiento que tenga Wallet; «Histórico desde» solo se usa si Wallet no lo indica.
              Se sincroniza solo cada 30 minutos (si no hay cambios no se descarga nada) y una vez por semana se repasa todo el histórico.
            </p>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import axios from '../config/axios';
import WalletExplorar from '../components/wallet/WalletExplorar.vue';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const TABS = [
  { id: 'resumen', label: 'Resumen', icon: 'bi-speedometer2' },
  { id: 'explorar', label: 'Explorar', icon: 'bi-compass' },
  { id: 'cuentas', label: 'Cuentas', icon: 'bi-bank' },
  { id: 'movimientos', label: 'Movimientos', icon: 'bi-list-ul' },
  { id: 'recurrentes', label: 'Recurrentes', icon: 'bi-arrow-repeat' },
  { id: 'auto', label: 'Reglas y alertas', icon: 'bi-bell' },
  { id: 'config', label: 'Configuración', icon: 'bi-gear' },
];

const TIPOS_CUENTA = {
  General: 'General', Cash: 'Efectivo', CurrentAccount: 'Cuenta corriente', CreditCard: 'Tarjeta de crédito',
  SavingAccount: 'Ahorro', Bonus: 'Bonos', Insurance: 'Seguro', Investment: 'Inversión', Loan: 'Préstamo',
  Mortgage: 'Hipoteca', Overdraft: 'Descubierto',
};

// Por qué se consideró traspaso entre cuentas propias
const ETIQUETA_MOTIVO = {
  pareja: 'traspaso · pareja', wallet: 'traspaso · Wallet', categoria: 'traspaso · Wallet',
  regla: 'traspaso · regla', palabra: 'traspaso · texto', manual: 'traspaso · manual',
};
const MOTIVOS_TRASPASO = {
  pareja: 'Detectado: el mismo importe sale de una cuenta y entra en otra tuya en ≤3 días. Confírmalo con ✓ o descártalo con ✕.',
  wallet: 'Wallet lo marca como transferencia',
  categoria: 'En Wallet tiene la categoría «Transferencia»',
  regla: 'Lo marca una de tus reglas',
  palabra: 'El texto indica un traspaso («traspaso», «cuenta propia»…)',
  manual: 'Lo marcaste tú como traspaso',
};

// Paleta categórica validada (slots 1 y 2)
const COLOR_INGRESOS = '#2a78d6';
const COLOR_GASTOS = '#eb6834';

export default {
  name: 'WalletView',
  components: { Bar, WalletExplorar },
  setup() {
    const tab = ref('resumen');
    const focoExplorar = ref(null);
    const cargando = ref(true);
    const sincronizando = ref(false);
    const guardando = ref(false);
    const error = ref('');
    const mensaje = ref('');
    const config = ref({ configured: false });
    const panel = ref(null);
    const meses = ref(12);
    const categorias = ref([]);
    const movimientos = ref([]);
    const pendientes = ref(0);
    const ultimos = ref([]);
    const ultimosPagina = ref(0);
    const ultimosHayMas = ref(false);
    const reglas = ref([]);
    const alertas = ref([]);
    const grupoEdit = ref(null);
    const tokenInput = ref('');
    const desdeInput = ref('');
    const caducaInput = ref('');
    const crearReglaAlCorregir = ref(true);
    const filtro = ref({ vista: 'revisar', categoria: '', mes: '', q: '' });
    const reglaNueva = ref({ patron: '', categoria_id: '' });
    const alertaNueva = ref({ tipo: 'saldo_bajo', objetivo: '', umbral: null });

    const tabsVisibles = computed(() => (config.value.configured ? TABS : TABS.filter((t) => t.id === 'config')));
    const kpis = computed(() => panel.value?.estadisticas?.kpis || {});
    const cuentasActivas = computed(() => (panel.value?.cuentas || []).filter((c) => !c.archivada));
    const cuentasDescuadradas = computed(() => (panel.value?.cuentas || []).filter((c) => c.avisos?.length));
    const avisoToken = computed(() => {
      const c = config.value;
      if (!c.configured) return null;
      if (c.ultimoSyncEstado === 'token_invalido') {
        return { clase: 'alert-danger', texto: 'Wallet ha rechazado el token (caducado o revocado). Genera uno nuevo para seguir sincronizando.' };
      }
      const d = c.diasParaCaducar;
      if (d == null || d > 30) return null;
      if (d < 0) return { clase: 'alert-danger', texto: `El token de Wallet caducó el ${fecha(c.tokenCaducaEl)}.` };
      const cuando = d === 0 ? 'hoy' : `en ${d} ${d === 1 ? 'día' : 'días'}`;
      return { clase: d <= 7 ? 'alert-danger' : 'alert-warning', texto: `El token de Wallet caduca ${cuando} (${fecha(c.tokenCaducaEl)}).` };
    });
    const categoriasMes = computed(() =>
      (panel.value?.estadisticas?.porCategoria || []).filter((c) => c.mesActual > 0 || c.mediaPrevia > 0).slice(0, 12)
    );
    const maxCategoria = computed(() => Math.max(1, ...categoriasMes.value.map((c) => Math.max(c.mesActual, c.mediaPrevia))));
    const costeRecurrente = computed(() =>
      (panel.value?.recurrentes || []).filter((r) => r.activo).reduce((a, r) => a + r.costeAnual, 0)
    );
    const sumaSeleccion = computed(() => {
      if (!grupoEdit.value || !panel.value) return 0;
      const sel = new Set(grupoEdit.value.cuentas);
      return panel.value.cuentas.filter((c) => sel.has(c.id)).reduce((a, c) => a + c.saldoBase, 0);
    });

    const divisa = () => panel.value?.divisaBase || 'EUR';
    const euros = (v) => importe(v, divisa());
    function importe(v, cur) {
      try {
        return new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur || 'EUR', useGrouping: 'always' }).format(Number(v) || 0);
      } catch {
        return `${(Number(v) || 0).toFixed(2)} ${cur || ''}`;
      }
    }
    const fecha = (iso) => (iso ? new Date(iso).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: '2-digit' }) : '');
    const fechaHora = (iso) => (iso ? new Date(iso).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : '');
    const nombreMes = (m) => {
      if (!m) return '';
      const [y, mm] = m.split('-').map(Number);
      return new Date(y, mm - 1, 1).toLocaleDateString('es-ES', { month: 'short', year: '2-digit' });
    };
    const tipoCuenta = (t) => TIPOS_CUENTA[t] || t;
    const barraPct = (v) => Math.round((v / maxCategoria.value) * 100);

    const chartMensual = computed(() => {
      const serie = panel.value?.estadisticas?.serieMensual || [];
      const comun = { borderRadius: 4, borderSkipped: 'start', maxBarThickness: 18, categoryPercentage: 0.7, barPercentage: 0.9 };
      return {
        labels: serie.map((f) => nombreMes(f.mes)),
        datasets: [
          { label: 'Ingresos', data: serie.map((f) => f.ingresos), backgroundColor: COLOR_INGRESOS, ...comun },
          { label: 'Gastos', data: serie.map((f) => f.gastos), backgroundColor: COLOR_GASTOS, ...comun },
        ],
      };
    });
    const chartOpciones = computed(() => ({
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: 'index', intersect: false },
      // Pulsar un mes abre Explorar con ese mes (gastos o ingresos según la barra)
      onClick: (_evt, els) => {
        const mes = panel.value?.estadisticas?.serieMensual?.[els?.[0]?.index]?.mes;
        if (mes) explorar({ tipo: els[0].datasetIndex === 0 ? 'ingreso' : 'gasto', mes });
      },
      onHover: (evt, els) => {
        if (evt?.native?.target) evt.native.target.style.cursor = els?.length ? 'pointer' : 'default';
      },
      plugins: {
        legend: { position: 'top', align: 'start', labels: { boxWidth: 10, boxHeight: 10 } },
        tooltip: {
          callbacks: {
            label: (ctx) => `${ctx.dataset.label}: ${euros(ctx.parsed.y)}`,
            footer: (items) => {
              const f = panel.value?.estadisticas?.serieMensual?.[items[0]?.dataIndex];
              return f ? `Ahorro: ${euros(f.ahorro)}${f.tasaAhorro != null ? ` (${f.tasaAhorro} %)` : ''}` : '';
            },
          },
        },
      },
      scales: {
        x: { grid: { display: false } },
        y: { beginAtZero: true, grid: { color: 'rgba(0,0,0,0.06)' }, ticks: { callback: (v) => euros(v).replace(/,00/, '') } },
      },
    }));

    function errorDe(e, fallback) {
      return e?.response?.data?.error || e?.message || fallback;
    }

    async function cargarConfig() {
      const { data } = await axios.get('/api/wallet/config');
      config.value = data;
      desdeInput.value = data.historialDesde || '';
      caducaInput.value = data.tokenCaducaEl || '';
      if (!data.configured) tab.value = 'config';
    }

    async function cargarPanel() {
      if (!config.value.configured) return;
      const { data } = await axios.get('/api/wallet/panel', { params: { meses: meses.value } });
      panel.value = data;
      if (data.config) config.value = data.config;
    }

    async function cargarCategorias() {
      const { data } = await axios.get('/api/wallet/categorias');
      categorias.value = data;
    }

    async function cargarMovimientos() {
      const params = { limit: 200 };
      if (filtro.value.vista === 'revisar') params.revisar = '1';
      if (filtro.value.categoria) params.categoria = filtro.value.categoria;
      if (filtro.value.vista === 'traspasos') params.categoria = '__traspaso';
      if (filtro.value.mes) params.mes = filtro.value.mes;
      if (filtro.value.q) params.q = filtro.value.q;
      const { data } = await axios.get('/api/wallet/movimientos', { params });
      movimientos.value = data;
      if (filtro.value.vista === 'revisar' && !filtro.value.categoria && !filtro.value.mes && !filtro.value.q) {
        pendientes.value = data.length;
      }
    }

    const POR_PAGINA_ULTIMOS = 10;
    async function cargarUltimos() {
      // Se pide uno de más para saber si existe página siguiente
      const { data } = await axios.get('/api/wallet/movimientos', {
        params: { limit: POR_PAGINA_ULTIMOS + 1, offset: ultimosPagina.value * POR_PAGINA_ULTIMOS },
      });
      ultimosHayMas.value = data.length > POR_PAGINA_ULTIMOS;
      ultimos.value = data.slice(0, POR_PAGINA_ULTIMOS);
    }
    function cambiarPaginaUltimos(delta) {
      ultimosPagina.value = Math.max(0, ultimosPagina.value + delta);
      accion(cargarUltimos);
    }

    async function cargarAuto() {
      const [r, a] = await Promise.all([axios.get('/api/wallet/reglas'), axios.get('/api/wallet/alertas')]);
      reglas.value = r.data;
      alertas.value = a.data;
    }

    async function cargarTodo() {
      cargando.value = true;
      error.value = '';
      try {
        await cargarConfig();
        if (config.value.configured) {
          await Promise.all([cargarPanel(), cargarCategorias(), cargarMovimientos(), cargarUltimos()]);
        }
      } catch (e) {
        error.value = errorDe(e, 'No se pudo cargar Wallet');
      } finally {
        cargando.value = false;
      }
    }

    async function accion(fn, okMsg) {
      error.value = '';
      mensaje.value = '';
      try {
        const r = await fn();
        if (okMsg) mensaje.value = typeof okMsg === 'function' ? okMsg(r) : okMsg;
        return r;
      } catch (e) {
        error.value = errorDe(e, 'Ha fallado la operación');
        return null;
      }
    }

    function cambiarTab(id) {
      tab.value = id;
      if (id === 'auto') accion(cargarAuto);
      if (id === 'movimientos') accion(cargarMovimientos);
    }

    async function sincronizar(completo) {
      sincronizando.value = true;
      await accion(
        async () => {
          const { data } = await axios.post('/api/wallet/sync', { completo }, { timeout: 300000 });
          await Promise.all([cargarPanel(), cargarCategorias(), cargarMovimientos(), cargarUltimos()]);
          return data;
        },
        (d) =>
          d.sinCambios
            ? 'Wallet no tiene cambios desde la última sincronización.'
            : `Sincronizado: ${d.cuentas} cuentas, ${d.movimientosNuevos} movimientos nuevos` +
              (d.movimientosBorrados ? `, ${d.movimientosBorrados} borrados` : '') +
              (d.traspasos ? `, ${d.traspasos} traspasos entre cuentas` : '') +
              (d.sinCategoria ? `. ${d.sinCategoria} sin categoría por revisar.` : '.')
      );
      sincronizando.value = false;
    }

    async function guardarConfig() {
      guardando.value = true;
      const r = await accion(async () => {
        const { data } = await axios.put('/api/wallet/config', {
          token: tokenInput.value,
          historial_desde: desdeInput.value,
          token_caduca_el: caducaInput.value,
        });
        config.value = data;
        caducaInput.value = data.tokenCaducaEl || '';
        tokenInput.value = '';
        return data;
      }, (d) => d.message);
      guardando.value = false;
      if (r && !panel.value) {
        tab.value = 'resumen';
        await sincronizar(false);
      }
    }

    // Un token nuevo dura como mucho 1 año: se propone esa fecha (editable)
    function alCambiarToken() {
      if (tokenInput.value && caducaInput.value === (config.value.tokenCaducaEl || '')) {
        caducaInput.value = new Date(Date.now() + 365 * 86400000).toISOString().slice(0, 10);
      }
    }

    async function cuadrarSaldo(c) {
      const valor = window.prompt(`Saldo que muestra Wallet hoy para «${c.nombre}»:`, String(c.saldo).replace('.', ','));
      if (valor == null) return;
      await accion(async () => {
        const { data } = await axios.put(`/api/wallet/cuentas/${encodeURIComponent(c.id)}/saldo-real`, { saldo: valor });
        await cargarPanel();
        return data;
      }, (d) => `Saldo cuadrado (ajuste ${importe(d.ajuste, c.divisa)}).`);
    }

    async function quitarAjuste(c) {
      await accion(async () => {
        await axios.delete(`/api/wallet/cuentas/${encodeURIComponent(c.id)}/saldo-real`);
        await cargarPanel();
      }, 'Ajuste quitado.');
    }

    async function desconectar() {
      if (!window.confirm('¿Desconectar Wallet? Se borrarán las cuentas, movimientos, reglas, grupos y alertas guardados en Vida.')) return;
      await accion(async () => {
        await axios.delete('/api/wallet/config');
        panel.value = null;
        await cargarConfig();
      }, 'Wallet desconectado.');
    }

    function nuevoGrupo() {
      grupoEdit.value = { id: null, nombre: '', cuentas: cuentasActivas.value.filter((c) => ['CurrentAccount', 'Cash', 'SavingAccount'].includes(c.tipo)).map((c) => c.id) };
    }
    function editarGrupo(g) {
      grupoEdit.value = { id: g.id, nombre: g.nombre, cuentas: [...g.cuentas] };
    }
    async function guardarGrupo() {
      const g = grupoEdit.value;
      await accion(async () => {
        const body = { nombre: g.nombre, cuentas: g.cuentas };
        if (g.id) await axios.put(`/api/wallet/grupos/${g.id}`, body);
        else await axios.post('/api/wallet/grupos', body);
        grupoEdit.value = null;
        await cargarPanel();
      });
    }
    async function borrarGrupo(g) {
      if (!window.confirm(`¿Borrar el grupo «${g.nombre}» y sus alertas?`)) return;
      await accion(async () => {
        await axios.delete(`/api/wallet/grupos/${g.id}`);
        await cargarPanel();
      });
    }

    const aceptandoTodos = ref(false);
    const traspasosPorConfirmar = computed(() => movimientos.value.filter((m) => m.traspaso_motivo === 'pareja').length);

    /** Confirma traspasos detectados por pareja: unos ids (y sus parejas) o, con null, todos. */
    async function aceptarTraspasos(ids) {
      if (!ids) aceptandoTodos.value = true;
      await accion(async () => {
        const { data } = await axios.post('/api/wallet/movimientos/aceptar-traspasos', ids ? { ids } : { todos: true });
        await Promise.all([cargarMovimientos(), cargarPanel()]);
        return data;
      }, (d) => `${d.confirmados} ${d.confirmados === 1 ? 'movimiento confirmado' : 'movimientos confirmados'} como traspaso entre cuentas.`);
      aceptandoTodos.value = false;
    }

    async function cambiarCategoria(m, categoriaId) {
      await accion(async () => {
        const { data } = await axios.put(`/api/wallet/movimientos/${encodeURIComponent(m.id)}/categoria`, {
          categoria_id: categoriaId || null,
          crear_regla: crearReglaAlCorregir.value && !!categoriaId && !!m.beneficiario,
        });
        await Promise.all([cargarMovimientos(), cargarPanel()]);
        return data;
      }, (d) => (d.reglaId ? `Regla creada; ${d.recategorizados} movimientos actualizados.` : 'Categoría guardada.'));
    }

    /** Abre Explorar con un foco (tipo, rango, categoría); por defecto el mes en curso. */
    function explorar({ tipo = 'gasto', categoria = null, mes = null } = {}) {
      const hoy = new Date();
      const [y, m] = mes ? mes.split('-').map(Number) : [hoy.getFullYear(), hoy.getMonth() + 1];
      const pad = (n) => String(n).padStart(2, '0');
      const ultimo = new Date(y, m, 0).getDate();
      const esMesActual = y === hoy.getFullYear() && m === hoy.getMonth() + 1;
      focoExplorar.value = {
        tipo,
        categoria,
        desde: `${y}-${pad(m)}-01`,
        hasta: `${y}-${pad(m)}-${pad(esMesActual ? hoy.getDate() : ultimo)}`,
        t: Date.now(), // fuerza el watch aunque se repita el mismo foco
      };
      tab.value = 'explorar';
    }

    function verCategoria(id) {
      explorar({ tipo: 'gasto', categoria: id, mes: panel.value?.estadisticas?.mesActual });
    }

    async function crearRegla() {
      await accion(async () => {
        const { data } = await axios.post('/api/wallet/reglas', reglaNueva.value);
        reglaNueva.value = { patron: '', categoria_id: '' };
        await Promise.all([cargarAuto(), cargarPanel()]);
        return data;
      }, (d) => `Regla creada; ${d.recategorizados} movimientos recategorizados.`);
    }
    async function borrarRegla(r) {
      await accion(async () => {
        await axios.delete(`/api/wallet/reglas/${r.id}`);
        await Promise.all([cargarAuto(), cargarPanel()]);
      });
    }

    async function crearAlerta() {
      const a = alertaNueva.value;
      const [objetivoTipo, objetivoId] = a.objetivo ? a.objetivo.split(/:(.+)/) : [null, null];
      await accion(async () => {
        await axios.post('/api/wallet/alertas', { tipo: a.tipo, objetivo_tipo: objetivoTipo, objetivo_id: objetivoId, umbral: a.umbral });
        alertaNueva.value = { tipo: a.tipo, objetivo: '', umbral: null };
        await cargarAuto();
      }, 'Alerta creada. Te llegará una notificación al móvil cuando se cumpla.');
    }
    async function toggleAlerta(a, activa) {
      await accion(async () => {
        await axios.put(`/api/wallet/alertas/${a.id}`, { activa });
        await cargarAuto();
      });
    }
    async function borrarAlerta(a) {
      await accion(async () => {
        await axios.delete(`/api/wallet/alertas/${a.id}`);
        await cargarAuto();
      });
    }

    function descripcionAlerta(a) {
      const nombre = (() => {
        if (a.objetivo_tipo === 'grupo') return panel.value?.grupos.find((g) => String(g.id) === a.objetivo_id)?.nombre;
        if (a.objetivo_tipo === 'categoria') return categorias.value.find((c) => c.id === a.objetivo_id)?.nombre;
        if (a.objetivo_tipo === 'cuenta') return panel.value?.cuentas.find((c) => c.id === a.objetivo_id)?.nombre;
        return 'cualquier cuenta';
      })() || '¿borrado?';
      if (a.tipo === 'saldo_bajo') return `${nombre}: saldo por debajo de ${euros(a.umbral)}`;
      if (a.tipo === 'categoria_mes') return `${nombre}: gasto del mes por encima de ${euros(a.umbral)}`;
      return `Cargo de más de ${euros(a.umbral)} en ${nombre}`;
    }

    // Movimientos recibidos desde la última marca de "visto" (guardada en el servidor, común a todos los dispositivos)
    const CLAVE_VISTO = 'wallet_visto_hasta'; // valor antiguo del navegador, solo para migrarlo
    const vistoHasta = ref('');
    const nuevosTotal = ref(0);
    const esNuevo = (m) => !!vistoHasta.value && !!m.importado_en && m.importado_en > vistoHasta.value;
    async function cargarNuevos() {
      let { data } = await axios.get('/api/wallet/movimientos/nuevos');
      if (!data.vistoHasta) {
        // Primera vez con marca en servidor: migra la del navegador (si la hay) o parte de ahora
        const antiguo = localStorage.getItem(CLAVE_VISTO) || '';
        await axios.post('/api/wallet/movimientos/visto', antiguo ? { hasta: antiguo } : {});
        ({ data } = await axios.get('/api/wallet/movimientos/nuevos'));
      }
      vistoHasta.value = data.vistoHasta || '';
      nuevosTotal.value = data.total || 0;
    }
    async function marcarVistos() {
      const { data } = await axios.post('/api/wallet/movimientos/visto');
      vistoHasta.value = data.vistoHasta;
      nuevosTotal.value = 0;
    }

    onMounted(async () => {
      await cargarTodo();
      try {
        await cargarNuevos();
      } catch (e) {
        nuevosTotal.value = 0;
      }
    });

    return {
      ETIQUETA_MOTIVO, MOTIVOS_TRASPASO, aceptarTraspasos, aceptandoTodos, traspasosPorConfirmar,
      tab, tabsVisibles, focoExplorar, explorar, cargando, sincronizando, guardando, error, mensaje, config, panel, meses, categorias,
      nuevosTotal, esNuevo, marcarVistos,
      ultimos, ultimosPagina, ultimosHayMas, cambiarPaginaUltimos,
      movimientos, pendientes, reglas, alertas, grupoEdit, tokenInput, desdeInput, caducaInput, crearReglaAlCorregir, filtro,
      reglaNueva, alertaNueva, kpis, cuentasActivas, cuentasDescuadradas, avisoToken, alCambiarToken, cuadrarSaldo, quitarAjuste, categoriasMes, costeRecurrente, sumaSeleccion, chartMensual,
      chartOpciones, euros, importe, fecha, fechaHora, nombreMes, tipoCuenta, barraPct, cambiarTab, cargarPanel,
      cargarMovimientos, sincronizar, guardarConfig, desconectar, nuevoGrupo, editarGrupo, guardarGrupo, borrarGrupo,
      cambiarCategoria, verCategoria, crearRegla, borrarRegla, crearAlerta, toggleAlerta, borrarAlerta, descripcionAlerta,
    };
  },
};
</script>

<style scoped>
.mov-nuevo > td {
  background-color: rgba(13, 110, 253, 0.12);
}

.wallet-page {
  max-width: 1200px;
}

.wallet-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.wallet-tabs .nav-link {
  white-space: nowrap;
  font-size: 0.875rem;
}

.kpi-link {
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
}

.kpi-link:hover,
.kpi-link:focus-visible {
  transform: translateY(-1px);
  box-shadow: 0 0.4rem 1rem rgba(0, 0, 0, 0.08) !important;
}

.kpi .card-body {
  padding: 0.9rem 1rem;
}

.kpi-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6c757d;
  font-weight: 600;
}

.kpi-value {
  font-size: 1.2rem;
  font-weight: 700;
  word-break: break-word;
}

.kpi-sub {
  font-size: 0.7rem;
  color: #6c757d;
}

.liquidez-total {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 0.4rem;
  vertical-align: middle;
}

.chart-box {
  position: relative;
  height: 280px;
}

.cat-bar {
  height: 4px;
  border-radius: 2px;
  background: #2a78d6;
  margin-top: 2px;
  min-width: 2px;
}

.mov-nota {
  max-width: 260px;
}

.mov-cat {
  min-width: 170px;
}

.fuente-aprendida {
  background: #fff3cd;
  color: #664d03;
}

.fuente-regla {
  background: #cfe2ff;
  color: #084298;
}

.pareja {
  max-width: 11rem;
}

.fuente-traspaso {
  background: #e9ecef;
  color: #495057;
}

.fuente-manual {
  background: #e2e3e5;
  color: #41464b;
}
</style>
